import * as React from "react"
import { connect } from "react-redux"
import Sticky from "react-sticky-el"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import bem from "../../../bem"
import { GlobalState } from "../../../store"
import { OldUIContext } from "../../../olduicontext"
import {
    mapDispatchToProps,
    DispatchProps,
    ClickStateTransitionButton,
} from "../actions"

import "./Footer.scss"
import { IResourceFooter } from "../index"

const b = bem.with("NewUI__footer")

type StateProps = IResourceFooter

type Props = StateProps & DispatchProps

export const ResourceFooter = ({
    isLoading,
    buttons,
    clickStateTransitionButton,
}: Props): JSX.Element => (
    <>
        {!!buttons.length && (
            <OldUIContext.Consumer>
                {(): JSX.Element => (
                    <div className={b()}>
                        <Sticky
                            mode="bottom"
                            className={b("container")}
                            positionRecheckInterval={1000 / 12}
                        >
                            <footer>
                                <div className="tw-p-4 bg-default">
                                    {buttons.map((button) => (
                                        <Action
                                            key={button.Code}
                                            isLoading={isLoading}
                                            actionType={ActionType.button}
                                            isTransparent={
                                                button.Type === "Dismissive" ||
                                                button.Type === "Secondary"
                                            }
                                            isSecondary={
                                                button.Type === "Dismissive"
                                            }
                                            onClick={(): ClickStateTransitionButton =>
                                                clickStateTransitionButton(
                                                    button.Id,
                                                )
                                            }
                                        >
                                            {button.FlowLabel}
                                        </Action>
                                    ))}
                                </div>
                            </footer>
                        </Sticky>
                    </div>
                )}
            </OldUIContext.Consumer>
        )}
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.resourceFooter,
})

export default connect(mapStateToProps, mapDispatchToProps)(ResourceFooter)
